import { ProcessedUltrasoundImage, UltrasoundImage } from "../../../utility/interfaces/patientMasterDataInterface";
import { formatDisplayDate } from './../../../utility/functions/common-functions';

export const parseUltrasoundImages = (
  images: UltrasoundImage[],
  date: string, 
  dateLanguage : string

): ProcessedUltrasoundImage[] => {
  return images?.map((img) => ({
    date: formatDisplayDate(date, dateLanguage),

    imageUrl: `data:image/${img.imageFormat.toLowerCase()};base64,${
      img.encodedImage
    }`,

    imageName: img.imageName,
  }));
};
